import {
  Button,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import dayjs from "dayjs"
import React, { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import { useHistory } from "react-router"
import { deleteCategory } from "~/actions/categories"
import HoverText from "~/components/Common/HoverText"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import CategoriesContext from "~/contexts/Categories"
import CategoryContext from "~/contexts/Category"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import serialize from "~/store/serialize"

import Box from "../../Common/Box"
import useStyles from "./styles"

const CategoryHeader = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()

  const mdDown = useMediaQuery(theme.breakpoints.down("md"))
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const nameSize = smDown ? 30 : mdDown ? 40 : 50
  const {
    category,
    updateDetails,
    debouncedDetails,
    setAnchorEl,
    handleClose,
    saveLoading,
  } = useContext(CategoryContext)
  const { refetchCategories } = useContext(CategoriesContext)
  const { closeDialog, openDialog } = useContext(AppContext)
  const openErrorSnackbar = useOpenErrorSnackbar()
  const queryClient = useQueryClient()

  //open menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClickDelete = () => {
    openDeleteCategoryDialog()
  }

  const deleteCategoryMutation = useMutation((id) =>
    deleteCategory(id, category),
  )

  const deleteCategoryConfirmed = () => {
    deleteCategoryMutation.mutate(category.id, {
      onSuccess: (res) => {
        serialize("category", res.client).then((serializedData) => {
          queryClient.setQueryData("categories", (oldData) => {
            let newArray = []
            newArray = oldData.map((x) => {
              if (x.id !== serializedData.id) {
                return x
              } else {
                return serializedData
              }
            })
            return newArray
          })
        })
      },
      onError: (err) => {
        openErrorSnackbar(err, "Error Deleting Category")
      },
      onSettled: () => {
        refetchCategories()
        closeDialog("confirmDialog", true)
      },
    })
  }

  // confirm delete function
  const confirmDelete = () => {
    if (category.id !== null) {
      deleteCategoryConfirmed()
    } else {
      closeDialog("confirmDialog", true)
    }
  }

  // open the dialog
  const openDeleteCategoryDialog = () => {
    let data = {
      id: category?.id,
      message: `Are you sure you would like to delete ${category.name}?`,
      confirmDelete: confirmDelete,
    }
    openDialog("confirmDialog", data).then(() => {
      handleClose()
      history.push("/categories")
      refetchCategories()
    })
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-evenly"
      className={classes.headerContainer}
    >
      <Box display="flex" justifyContent="space-between" flexWrap="wrap">
        <Box marginLeft="16px">
          <HoverText
            data={
              debouncedDetails?.name !== ""
                ? debouncedDetails?.name
                : category?.name
            }
            variant="h1"
            size={nameSize}
            className={classes.title}
          />
        </Box>
        <Box
          marginRight="16px"
          marginLeft="16px"
          className={classes.saveContainer}
        >
          <>
            <PermissionsWrapper permissionGroup="admin">
              <Button
                variant="contained"
                size="small"
                onClick={handleClickDelete}
                className={classes.deleteBtn}
              >
                Delete
              </Button>
            </PermissionsWrapper>
            <PermissionsWrapper permissionGroup="admin">
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={updateDetails}
                className={classes.saveBtn}
              >
                {saveLoading ? (
                  <Box height="20px" width="30px">
                    <CircularProgress size={10} style={{ color: "#fff" }} />
                  </Box>
                ) : (
                  "Save"
                )}
                {/* <div>
                <CourseLessonMenuItem
                  func={updateDetails}
                  loadingState={false}
                  text="SAVE"
                />
              </div> */}
              </Button>
            </PermissionsWrapper>
          </>
        </Box>
      </Box>
      <Box
        marginLeft="16px"
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        className={classes.detailBox}
      >
        <Box className={classes.lastUpdated}>
          <Typography variant="subtitle2" className={classes.updated}>
            Last Updated {dayjs(category?.updated)?.format("M/D/YYYY")}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default CategoryHeader
